import styled from 'styled-components';

export {
  LoginPage,
  LoginCard,
  LogoWrapper,
  LoginHeading,
  FieldGroup,
  FieldLabel,
  FieldError,
  SubmitButton,
  FooterText,
} from 'Pages/Login/styles';

export const OtpRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;

// Bespoke 50x50 OTP box — not CLOSED_SX (that's a 40px closed-select-height
// box; this widget's square shape is functionally load-bearing to the
// 6-box layout, not an arbitrary style). size="sm" opts out of CLOSED_SX
// entirely so this sx has a clean slate to work from.
export const OTP_SX = {
  '& .MuiOutlinedInput-root': {
    width: '50px',
    height: '50px',
    borderRadius: '4px',
  },
  '& .MuiOutlinedInput-input': {
    height: '50px',
    boxSizing: 'border-box',
    padding: 0,
    textAlign: 'center',
    fontSize: '18px',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'var(--vo-steel)',
  },
  '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: 'var(--vo-steel)',
  },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: 'var(--vo-celeste)',
    borderWidth: '1px',
  },
};
